const countableItems = {
    AGE: ['год', 'года', 'лет'],
    PERSON: ['человек', 'человека', 'человек'],
    TOURIST: ['турист', 'туриста', 'туристов'],
    DAY: ['день', 'дня', 'дней'],
    SELECTED: ['Выбран', 'Выбрано', 'Выбрано'],
    USD: ['доллар', 'доллара', 'долларов'],
    EUR: ['евро', 'евро', 'евро'],
    RUB: ['рубль', 'рубля', 'рублей'],
    SERVICE: ['Опция', 'Опции', 'Опций'],
    SERVICESMALL: ['опция', 'опции', 'опций'],
    COUNTRY: ['страна', 'страны', 'стран'],
    OFFER: ['предложение', 'предложения', 'предложений'],
    POLICY: ['полис', 'полиса', 'полисов'],
    BACKSPACE: ['пробела', 'пробелов', 'пробелов'],
};
export function getTypes(type) {
    return countableItems[type];
}
